import {s_r_e as lang} from '~/lang/ru';
import {Modal} from '~/4trend/Modal';
import {RequestView} from './RequestView';

export const createRequestView = (request) => {
	const modal = new Vue({
		mounted() {
			this.$refs.modal.$el.querySelector('.modal-dialog').classList.add('modal-dialog-centered', 'modal-lg');
		},
		beforeDestroy() {
			this.$el.parentElement.removeChild(this.$el);
		},
		computed: {
			title: () => {
				return `${lang('REQUEST_MODAL')} #${request?.name}`;
			},
		},
		render() {
			return (
				<Modal
					ref="modal"
					title={this.title}
					onHidden={() => this.$destroy()}
				>
					<RequestView request={request}/>
				</Modal>
			);
		},
	});

	modal.$mount();
	document.body.appendChild(modal.$el);

	modal.$refs.modal.show();

	return modal;
}
